import { Link } from "react-router-dom";
import { TELEGRAM_URL } from "@/lib/api";

export const Footer = () => (
  <footer className="relative z-[2] border-t border-white/10 mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 pt-10 pb-28 lg:pb-10 flex flex-col sm:flex-row gap-4 justify-between text-sm text-gray-500">
      <p>© {new Date().getFullYear()} GameRealm — digital game activation keys. Payments in USDT only.</p>
      <div className="flex flex-wrap gap-x-5 sm:gap-x-6 gap-y-0 sm:gap-y-2 [&>a]:py-2.5 sm:[&>a]:py-0">
        <Link to="/blog" data-testid="footer-blog-link" className="hover:text-white transition-colors">Blog</Link>
        <Link to="/faq" data-testid="footer-faq-link" className="hover:text-white transition-colors">FAQ</Link>
        <Link to="/policies#shipping" data-testid="footer-shipping-link" className="hover:text-white transition-colors">Shipping</Link>
        <Link to="/policies#refund" data-testid="footer-refund-link" className="hover:text-white transition-colors">Refunds</Link>
        <Link to="/policies#return" data-testid="footer-return-link" className="hover:text-white transition-colors">Returns</Link>
        <Link to="/order" data-testid="footer-track-order-link" className="hover:text-white transition-colors">Track order</Link>
        <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-telegram-link" className="text-sky-400 hover:text-sky-300 transition-colors">Telegram @Randal782</a>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors">Admin</Link>
      </div>
    </div>
  </footer>
);
